jQuery(document).ready(function() {
	jQuery(".share-anchor").click(function(e) {
        e.preventDefault();
        var shareUrl = jQuery(this).data('share-url');
        window.open(shareUrl, '_blank', 'toolbar=yes, scrollbars=yes, resizable=yes, top=200, left=500, width=500, height=300'); 
    });
    var url = window.predsednikSettings.baseUrl + '/action/send';
    // jQuery('#submit-form').on('click',function(e) {
    //     e.preventDefault();
    //     var formName = jQuery('#formName');
    //     var formPhone = jQuery('#formPhone');
    //     var formTopic = jQuery('#formTopic');
    //     var formEmail = jQuery('#formEmail');
    //     var formMessage = jQuery('#formMessage');
    //     var grResponse = grecaptcha.getResponse();
    //     var responseMessage = jQuery('#responseMessage');
    //     formName.on('focus', function(e) {
    //         formName.closest('.form-group').removeClass('error-border')
    //         responseMessage.removeClass('open')
    //     });
    //     formPhone.on('focus', function(e) {
    //         formPhone.closest('.form-group').removeClass('error-border')
    //         responseMessage.removeClass('open')
    //     });
    //     formTopic.on('focus', function(e) {
    //         formTopic.closest('.form-group').removeClass('error-border')
    //         responseMessage.removeClass('open')
    //     });
    //     formEmail.on('focus', function(e) {
    //         formEmail.closest('.form-group').removeClass('error-border');
    //         responseMessage.removeClass('open')
    //     });
    //     formMessage.on('focus', function(e) {
    //         formMessage.closest('.form-group').removeClass('error-border')
    //         responseMessage.removeClass('open')
    //     });
    //     var postFunction = function() {
    //         var formData = {
    //             "name": formName.val(),
    //             "email": formEmail.val(),
    //             "phone": formPhone.val(),
    //             "subject": formTopic.val(),
    //             "message": formMessage.val(),
    //             "g-recaptcha-response": grResponse
    //         }
    //         jQuery.ajax({
    //             type:"POST",
    //             contentType:'application/json',
    //             url:url,
    //             data: JSON.stringify(formData),
    //             dataType:'json',
    //             success: function(response) {
    //                 console.log(response)
    //                 responseMessage.text(response.message)
    //                 responseMessage.removeClass('error');
    //                 responseMessage.addClass('success open');
    //                 formName.val('');
    //                 formPhone.val('');
    //                 formTopic.val('');
    //                 formMessage.val('');
    //                 formEmail.val('');
    //                 grecaptcha.reset();
    //                 setTimeout(function() {
    //                     responseMessage.removeClass('success open')
    //                 }, 5000)
    //             },
    //             error: function(err) {
    //                 // console.log(err.responseJSON.error.message)
    //                 responseMessage.removeClass('success');
    //                 responseMessage.addClass('error open');
    //                 responseMessage.text(err.responseJSON.error.message);
    //                 grecaptcha.reset();
    //                 setTimeout(function() {
    //                     responseMessage.removeClass('error open')
    //                 }, 5000)
    //             },
    //             complete: function() {
    //             }
    //         })
    //     }
    //     var valid = true;
    //     if(!formName.val()) {
    //         valid = false;
    //         formName.closest('.form-group').addClass('error-border')
    //     } 
        
    //     if(!formPhone.val()) {
    //         valid = false;
    //         formPhone.closest('.form-group').addClass('error-border') 
    //     }
    //     if(!formTopic.val()) {
    //         valid = false;
    //         formTopic.closest('.form-group').addClass('error-border') 
    //     }
    //     if(!formMessage.val()) {
    //         valid = false;
    //         formMessage.closest('.form-group').addClass('error-border')
    //     }
    //     function validateEmail(value) {
    //         var emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //         return emailReg.test( value );
    //     }
    //     if(!validateEmail(formEmail.val()) || !formEmail.val()) {
    //         valid = false;
    //         formEmail.closest('.form-group').addClass('error-border');
    //     }
    //     // if(!grResponse) {
    //     //     valid = false;
    //     // }
    //     if (valid == true) {
    //         postFunction(); 
    //     } 
    // })
	var onResize = function() {
    }

    var onScroll = function() {
       
    }
    onResize()
    jQuery(window).scroll(onScroll)
    jQuery(window).resize(onResize);
})